import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUserUpdateMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (response: Api.IUser) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ user }: { user: Api.IUser }) => {
			return userSession.webServiceHelper.callAsync<Api.IUser>(`user/${encodeURIComponent(user.id)}`, 'PUT', user);
		},
		onError,
		onSuccess,
	});
}
